import { Box } from "@mui/material";

const companyLogos = [
  require("../../assets/images/logo-abinsula.png"),
  require("../../assets/images/crs4_small-2.png"),
  require("../../assets/images/greenshare-300x75.png"),
  require("../../assets/images/logoHeaderGlowsamarigosa-300x177.png"),
  require("../../assets/images/uniss-300x89.png"),
  require("../../assets/images/logo_mimit.png"),
];

const LogoContainer = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-around"
      width="100%"
      height="100%"
      p={2}
      boxSizing="border-box"
    >
      {companyLogos.map((logo, index) => (
        <img
          key={index}
          src={logo}
          alt={`Logo azienda ${index + 1}`}
          style={{
            height: 80,
            objectFit: "contain",
            width: 200,
          }}
        />
      ))}
    </Box>
  );
};

export default LogoContainer;
